import uniqid from 'uniqid';
import type { RegisterOptions } from 'react-hook-form';

import { STATES } from 'constants/states';

export type BasicInfoFormMode = 'CREATE_MODE' | 'EDIT_MODE' | 'CREATE_AND_EDIT_MODE';

export interface BasicInfoFormField {
  name: string;
  label: string;
  componentProps: Record<string, unknown>;
  rules: RegisterOptions;
  mode: BasicInfoFormMode;
  key: string;
  isSelect?: boolean;
}

export const BASIC_INFO_FORM_FIELDS: BasicInfoFormField[] = [
  {
    name: 'name',
    label: 'Client Name',
    componentProps: {
      helperText: 'The ID of the school in PowerBI',
      'data-testid': 'client-name-input',
    },
    rules: {
      required: 'This field is required. Please enter Client Name',
      pattern: /^.+\S$/,
    },
    mode: 'CREATE_AND_EDIT_MODE',
    key: uniqid(),
  },
  {
    name: 'externalId',
    label: 'Client ID',
    componentProps: {
      helperText: 'The ID of the school in PowerBI',
      'data-testid': 'client-id-input',
      inputMode: 'numeric',
    },
    rules: {
      required: 'This field is required. Please enter Client ID',
      pattern: {
        value: /^\d+$/,
        message: 'Client ID must contain only numbers',
      },
    },
    mode: 'CREATE_MODE',
    key: uniqid(),
  },
  {
    name: 'authorizedDomains',
    label: 'Authorized domains',
    componentProps: {
      isMulti: true,
      helperText: `e.g. "@schoolname.edu" and press space or enter to separate multiple domains`,
      'data-testid': 'authorized-domains-input',
    },
    rules: {
      required: 'This field is required. Please enter Authorized domains',
      min: 1,
    },
    isSelect: true,
    mode: 'CREATE_AND_EDIT_MODE',
    key: uniqid(),
  },
  {
    name: 'state',
    label: 'State',
    componentProps: {
      options: STATES,
      'data-testid': 'state-input',
    },
    rules: {
      required: 'This field is required. Please select an option from the list',
    },
    isSelect: true,
    mode: 'CREATE_AND_EDIT_MODE',
    key: uniqid(),
  },
  {
    name: 'expireDate',
    label: 'Expire date',
    componentProps: {
      'data-testid': 'expire-date-input',
    },
    rules: {
      required: 'This field is required. Please enter Expire date',
      pattern: /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/,
    },
    mode: 'EDIT_MODE',
    key: uniqid(),
  },
];
